import type { deCampaigns } from './de.campaigns';

export const trCampaigns: Record<keyof typeof deCampaigns, string> = {
  'nav.campaigns': 'Kampanyalar',

  'campaigns.title': 'Kampanyalar',
  'campaigns.empty': 'Henüz kampanya yok. İlk kampanyanızı oluşturun.',
  'campaigns.create': 'Kampanya oluştur',
  'campaigns.name': 'Ad',
  'campaigns.description': 'Açıklama',
  'campaigns.open': 'Aç',
  'campaigns.showArchived': 'Arşivlenenleri göster',
  'campaigns.state.active': 'Çalışıyor',
  'campaigns.state.stopped': 'Durduruldu',
  'campaigns.state.archived': 'Arşivlendi',
  'campaigns.mode.pool': 'Ortak liste',
  'campaigns.mode.assigned': 'Sabit dağıtım',
  'campaigns.contacts': 'Kayıtlar',

  'campaign.tab.overview': 'Genel bakış',
  'campaign.tab.contacts': 'Kayıtlar',
  'campaign.tab.callers': 'Temsilciler',
  'campaign.tab.statistics': 'İstatistik',
  'campaign.tab.recordings': 'Kayıtlar (ses)',
  'campaign.tab.settings': 'Ayarlar',
  'campaign.comingSoon': 'Bu bölüm sonraki adımlarda gelecek.',
  'campaign.start': 'Kampanyayı başlat',
  'campaign.stop': 'Kampanyayı durdur',
  'campaign.archive': 'Arşivle',
  'campaign.restore': 'Arşivden çıkar',
  'campaign.delete': 'Kampanyayı sil',
  'campaign.deleteWarning':
    'Kampanya ve kayıtları görünümünüzden kaldırılır. Bu adım geri alınamaz.',
  'campaign.stopFirst': 'Bu ayarı değiştirmeden önce kampanyayı durdurun.',

  'campaign.overview.contacts': 'Kayıtlar',
  'campaign.overview.callers': 'Yetkili temsilciler',
  'campaign.overview.mode': 'Çalışma şekli',
  'campaign.overview.state': 'Durum',
  'campaign.overview.created': 'Oluşturulma tarihi',

  'campaign.settings.basics': 'Temel bilgiler',
  'campaign.settings.mode': 'Çalışma şekli',
  'campaign.settings.modeHint':
    'Ortak liste: tüm temsilciler aynı listeyi işler. Sabit dağıtım: her temsilci kendi kayıtlarını alır.',
  'campaign.settings.changeMode': 'Çalışma şeklini değiştir',
  'campaign.settings.modePreview': 'Bu {contacts} kaydı ve {callers} temsilciı etkiler. Devam edilsin mi?',
  'campaign.settings.country': 'Telefon numaralarının ülkesi',
  'campaign.settings.countryHint': 'Ülke kodu olmayan numaralar bu ülkeyle tamamlanır.',
  'campaign.settings.advanced': 'Gelişmiş ayarlar',
  'campaign.settings.parallelCalls': 'Eş zamanlı arama denemesi',
  'campaign.settings.parallelMode': 'Sayım',
  'campaign.settings.parallelMode.per_caller': 'temsilci başına',
  'campaign.settings.parallelMode.global': 'toplam',
  'campaign.settings.parallelWarning':
    'Bu değerde aradığınız kişiler kısa süre beklemede kalabilir.',
  'campaign.settings.retry': '24 saat içindeki tekrar denemeleri',
  'campaign.settings.recording': 'Görüşmeleri kaydet',
  'campaign.settings.mailbox': 'Telesekreteri algıla',
  'campaign.settings.inbound': 'Gelen aramaları kabul et',
  'campaign.settings.queue': 'Bekleme sırası',
  'campaign.settings.queueWait': 'Saniye cinsinden en uzun bekleme',
  'campaign.settings.fields': 'Kendi alanlarınız',
  'campaign.settings.fieldsHint':
    'Kayıtlarınız için ek bilgiler. İçe aktarma sırasında oluşan alanlar da burada görünür.',
  'campaign.settings.fieldName': 'Alan adı',
  'campaign.settings.addField': 'Alan ekle',
  'campaign.settings.required': 'Görüşme bitmeden doldurulsun',
  'campaign.settings.removeField': 'Alanı kaldır',
  'campaign.settings.saved': 'Kaydedildi.',

  'campaign.callers.title': 'Yetkili temsilciler',
  'campaign.callers.hint': 'Bu kampanyanın kayıtlarını yalnızca yetkili temsilciler görür.',
  'campaign.callers.add': 'Temsilciı yetkilendir',
  'campaign.callers.remove': 'Yetkiyi kaldır',
  'campaign.callers.empty': 'Bu kampanya için henüz kimse yetkilendirilmedi.',
  'campaign.callers.assignedContacts': 'atanmış kayıt',
  'campaign.callers.removed': 'Yetki kaldırıldı. {count} kayıt artık kimseye atanmadı.',

  'contacts.title': 'Kayıtlar',
  'contacts.search': 'Ara',
  'contacts.searchHint': 'Numara, ad, not veya kayıt numarası',
  'contacts.empty': 'Henüz kayıt yok.',
  'contacts.noResults': 'Bu aramaya uyan kayıt yok.',
  'contacts.create': 'Kayıt oluştur',
  'contacts.import': 'CSV içe aktar',
  'contacts.export': 'CSV olarak indir',
  'contacts.total': '{count} kayıt',
  'contacts.page': 'Sayfa {page} / {pages}',
  'contacts.next': 'İleri',
  'contacts.previous': 'Geri',
  'contacts.filter.status': 'Durum',
  'contacts.filter.all': 'Tümü',
  'contacts.filter.assigned': 'Temsilci',
  'contacts.filter.archived': 'Arşiv',
  'contacts.filter.archived.active': 'Etkin',
  'contacts.filter.archived.archived': 'Arşivlenen',
  'contacts.filter.archived.all': 'Tümü',
  'contacts.filter.callbackFrom': 'Geri arama başlangıcı',
  'contacts.filter.callbackTo': 'Geri arama bitişi',

  'contact.id': 'Kayıt numarası',
  'contact.phone': 'Telefon numarası',
  'contact.firstName': 'Ad',
  'contact.lastName': 'Soyad',
  'contact.note': 'Not',
  'contact.status': 'Durum',
  'contact.callbackDate': 'Geri arama tarihi',
  'contact.assignedTo': 'Atanan kişi',
  'contact.unassigned': 'Kimseye atanmadı',
  'contact.archive': 'Arşivle',
  'contact.restore': 'Geri al',
  'contact.delete': 'Sil',
  'contact.deleteWarning': 'Bu kayıt görünümünüzden kaldırılır.',
  'contact.saved': 'Kaydedildi.',
  'contact.archived': 'Arşivlendi',
  'contact.duplicateHint': 'Bu numara {id} numaralı kayıtta zaten var.',
  'contact.requiredBeforeCall': 'Görüşme bitmeden doldurulmalı',

  'status.new': 'Yeni',
  'status.successful': 'Başarılı',
  'status.callback': 'Geri arama',
  'status.not_interested': 'İlgilenmiyor',

  'import.title': 'CSV içe aktar',
  'import.step.file': 'Dosya seç',
  'import.step.mapping': 'Sütunları eşle',
  'import.step.duplicates': 'Yinelenen kayıtlar',
  'import.step.result': 'Sonuç',
  'import.chooseFile': 'CSV dosyası seç',
  'import.fileHint': 'Yalnızca CSV dosyaları, en fazla 20 MB.',
  'import.preview': 'Önizleme',
  'import.rows': 'toplam satır',
  'import.validPhones': 'geçerli telefon numarası',
  'import.invalidPhones': 'geçersiz telefon numarası',
  'import.duplicates': 'yinelenen numara',
  'import.withId': 'kayıt numarası olan satır',
  'import.mapping.phone': 'Telefon numarası sütunu',
  'import.mapping.firstName': 'Ad sütunu',
  'import.mapping.lastName': 'Soyad sütunu',
  'import.mapping.none': '– aktarma –',
  'import.mapping.hint': 'Kalan tüm sütunlar kampanyanın kendi alanları olarak aktarılır.',
  'import.duplicates.question': 'Zaten var olan numaralarda ne yapılsın?',
  'import.duplicates.skip': 'Var olan kayıtlar değişmeden kalsın',
  'import.duplicates.overwrite': 'Var olan kayıtlar yeni bilgilerle tamamlansın',
  'import.duplicates.overwriteHint': 'Boş sütunlar var olan bilgilerin üzerine yazmaz.',
  'import.start': 'İçe aktarmayı başlat',
  'import.running': 'İçe aktarma sürüyor …',
  'import.result.created': 'yeni oluşturuldu',
  'import.result.updated': 'güncellendi',
  'import.result.skippedDuplicates': 'atlandı (zaten var)',
  'import.result.skippedInvalid': 'atlandı (hatalı)',
  'import.result.createdFields': 'Yeni alanlar',
  'import.result.errors': 'Hatalı satırlar',
  'import.error.invalid_phone': '{line}. satır: telefon numarası kullanılamıyor',
  'import.error.missing_phone': '{line}. satır: telefon numarası yok',
  'import.error.unknown_public_id': '{line}. satır: bilinmeyen kayıt numarası',
  'import.done': 'Tamam',

  'error.campaign.not_found': 'Bu kampanya bulunamadı.',
  'error.campaign.name_required': 'Lütfen kampanya için bir ad girin.',
  'error.campaign.must_be_stopped': 'Bu ayarı değiştirmeden önce kampanyayı durdurun.',
  'error.campaign.no_callers_assigned': 'Önce kampanyaya en az bir temsilci atayın.',
  'error.campaign.archived_cannot_activate': 'Arşivlenmiş bir kampanya başlatılamaz.',
  'error.campaign.not_released': 'Bu kampanya sizin için yetkilendirilmedi.',
  'error.campaign.member_required': 'Bu temsilci kampanya için yetkilendirilmedi.',
  'error.campaign.member_not_found': 'Bu erişim kampanya için yetkilendirilmedi.',
  'error.campaign.parallel_out_of_range': 'Lütfen 1 ile 5 arasında bir değer seçin.',
  'error.campaign.invalid_country': 'Bu ülke kullanılamıyor.',
  'error.contact.not_found': 'Bu kayıt bulunamadı.',
  'error.contact.invalid_phone': 'Bu telefon numarasını kullanamıyoruz. Lütfen girişi kontrol edin.',
  'error.contact.invalid_status': 'Bu durum kullanılamıyor.',
  'error.contact.invalid_callback_date': 'Lütfen geçerli bir tarih girin.',
  'error.contact.assignment_admin_only': 'Atamayı yalnızca bir yönetici değiştirebilir.',
  'error.field.not_found': 'Bu alan bulunamadı.',
  'error.field.name_taken': 'Bu adda bir alan zaten var.',
  'error.field.name_required': 'Lütfen alan için bir ad girin.',
  'error.field.name_reserved': 'Bu ad sabit bir sütun tarafından kullanılıyor. Lütfen başka bir ad seçin.',
  'error.import.file_required': 'Lütfen bir CSV dosyası seçin.',
  'error.import.empty_file': 'Dosya boş.',
  'error.import.file_too_large': 'Dosya çok büyük. Lütfen listeyi birkaç dosyaya bölün.',
  'error.import.not_found': 'Yüklenen dosya artık mevcut değil. Lütfen yeniden yükleyin.',
  'error.import.phone_column_required': 'Lütfen telefon numarasının bulunduğu sütunu seçin.',
};
